goog.provide('el8.tourguide.passportPhysicianSplash');

goog.require('el8.tourguide.Splash');
goog.require('el8.template.tourguide.passportPhysicianSplash');

el8.tourguide.passportPhysicianSplash = (function() {

    var that = new el8.tourguide.Splash({
        opacity: 0.7,
        zIndex: 5,
        backgroundColor: 'black',
        contentFn: el8.template.tourguide.passportPhysicianSplash.slide1,
        clickTriggerMap: {
            '.next-trigger': function() {
                that.setContent(el8.template.tourguide.passportPhysicianSplash.slide2());
                that._positionDialog();
            },
            '.end-trigger': function() {
                that.hide();
            }
        }
    });

    return that;

})();


